import { EMPTY } from 'rxjs';
export class NoProgressReport {
    // eslint-disable-next-line no-use-before-define
    static instance = new NoProgressReport();
    get steps$() { return EMPTY; }
    get retries$() { return EMPTY; }
    constructor() {
    }
    retry(_index, _count) {
    }
    step(_index, _total) {
    }
}
//# sourceMappingURL=no-progress-report.js.map